module.exports = __webpack_public_path__ + "static/32-e00fe23328e6d5b653a4ed74a4e6440c.jpg";